

















import { Vue, Component, Emit, Prop } from 'vue-property-decorator';
import moment from 'moment';
import { isEmpty } from 'ramda';
import DatePicker from 'vue2-datepicker';

@Component({
    components: {
        DatePicker
    }
})
export default class Tours extends Vue {
    private pickday: string = '';
    private pickPoint: string = '';
    private lang: string = document.documentElement.lang;
    private selection: { start: string; pickPoint: string } | null = null;

    get now() {
        return moment();
    }

    private selected() {
        let start = this.pickday;
        let date: any = null;

        if (isEmpty(start)) {
            date = moment();
        } else {
            date = moment(start);
        }

        start = date.format('DD/MM/YYYY');

        this.selection = {
            start,
            pickPoint: this.pickPoint
        };
        this.change();
    }

    @Emit()
    private change(): { start: string; pickPoint: string } | null {
        return this.selection;
    }
}
